module.exports = "https://api.mapbox.com/styles/v1/{user}/{id}/tiles/{z}/{x}/{y}{extension}?access_token={accessToken}\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/map/mapURL.txt
 ** module id = 62
 ** module chunks = 0
 **/